import React from 'react';

const HumidityIcon = ({
  width = 31,
  height = 31,
  fill = 'none',
  className,
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 62 62' className={className}>
      <g fill={fill} fillRule='evenodd'>
        <path fill='#FFF' d='M21 35.5c-.364-2.916.5-5.573 2.5-8.5 1-1.573 3.655-6.03 6-9.5 2.21 3.349 5 8 6 9.5 1.5 2 3 4.5 2.5 8.5s-3 8-8.468 8c-5.532 0-8.032-4-8.532-8zM39 26h4v1h-4v-1zm2 4h4v1h-4v-1zm1 4h4v1h-4v-1zm-2 4h4v1h-4v-1z'
        />
        <circle cx='31' cy='31' r='30.5' stroke='#FFF' />
      </g>
    </svg>
  );
};

export default HumidityIcon;


// WEBPACK FOOTER //
// ./src/app/intro/components/HumidityIcon/HumidityIcon.js